import { useEffect, useState } from "react";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";
import { useBulkOrderMode } from "../../hooks/useAuthorisation";
// State Import
import { useRequestList } from "../../state/requestListState";
// Component imports
import { RequestListHeader } from "./RequestListHeader";
import { RequestTable } from "./RequestTable";
import { RequestFilterBar } from "./RequestFilterBar";
// MUI
import Typography from "@mui/material/Typography";

export function RequestList({ status }) {
  const bulkOrderMode = useBulkOrderMode();
  // Single source of truth for merging, so the table never shows checkboxes
  // without the header offering the action that consumes them.
  const canMerge = status === "approvals" && !bulkOrderMode;

  // Data Grid Columns
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    createdName: false,
    approvalBy: false,
    amount: false,
  });

  const [requestFilter, setRequestFilter] = useUrlFilterState(
    {
      type: status,
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["type", "pageSize"] },
  );

  const [requestList, setRequestList] = useState({
    filter: {},
    paging: {},
    order: [],
  });

  // Fetch Order List
  const { isPending, isError, data, error, isFetching, isSuccess } =
    useRequestList(requestFilter);

  // Success Function
  const successFunc = () => {
    setRequestList(data.data.data.data.list);
  };
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  // State to hold order rows selected by the user
  const [selectedRows, setSelectedRows] = useState([]);

  // Selections persist across pages by design, but a change of filter swaps the
  // result set for a different one, so anything still selected is now hidden.
  const selectionScopeKey = JSON.stringify([
    requestFilter.type,
    requestFilter.search,
  ]);
  useEffect(() => {
    setSelectedRows([]);
  }, [selectionScopeKey]);

  return (
    <>
      <RequestListHeader
        status={status}
        canMerge={canMerge}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
      <RequestFilterBar
        status={status}
        requestFilter={requestFilter}
        setRequestFilter={setRequestFilter}
        setColumnVisibilityModel={setColumnVisibilityModel}
      />
      {isError && <Typography>Error: {error.message}</Typography>}
      <RequestTable
        status={status}
        data={requestList}
        loading={isFetching}
        requestFilter={requestFilter}
        setRequestFilter={setRequestFilter}
        columnVisibilityModel={columnVisibilityModel}
        canMerge={canMerge}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
    </>
  );
}
